import { render, staticRenderFns } from "./databaseQuery.vue?vue&type=template&id=34b4980c&scoped=true"
import script from "./databaseQuery.vue?vue&type=script&lang=js"
export * from "./databaseQuery.vue?vue&type=script&lang=js"
import style0 from "./databaseQuery.vue?vue&type=style&index=0&id=34b4980c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b4980c",
  null
  
)

export default component.exports